<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" md="8" class="d-flex flex-row align-center">
        <v-list dense class="d-flex flex-row align-center">
          <v-img src="@/assets/circle_green.svg" width="20" height="20" contain />
          <v-list-item-action-text class="ml-1 mr-3">
            Низкий уровень
          </v-list-item-action-text>

          <v-img src="@/assets/circle_yellow.svg" width="20" height="20" contain />
          <v-list-item-action-text class="ml-1 mr-3">
            Повышенный уровень
          </v-list-item-action-text>

          <v-img src="@/assets/circle_orange.svg" width="20" height="20" contain />
          <v-list-item-action-text class="ml-1 mr-3">
            Высокий уровень
          </v-list-item-action-text>

          <v-img src="@/assets/circle_red.svg" width="20" height="20" contain />
          <v-list-item-action-text class="ml-1 mr-3">
            Очень высокий уровень
          </v-list-item-action-text>

          <v-img src="@/assets/circle_purple.svg" width="20" height="20" contain />
          <v-list-item-action-text class="ml-1 mr-3">
            Очень высокий уровень
          </v-list-item-action-text>

          <v-img src="@/assets/circle_burgundy.svg" width="20" height="20" contain />
          <v-list-item-action-text class="ml-1 mr-3">
            Очень высокий уровень
          </v-list-item-action-text>
        </v-list>
      </v-col>

      <v-spacer></v-spacer>

      <v-checkbox v-model="clarity" class="ml-4 my-0">
        <template v-slot:label>
          <span style="font-size: 0.8rem;">Clarity: 54</span>
        </template>
      </v-checkbox>
      <v-checkbox v-model="icmaos" class="ml-4 my-0">
        <template v-slot:label>
          <span style="font-size: 0.8rem;">Эко-посты: 20</span>
        </template>
      </v-checkbox>
      <v-checkbox v-model="gidromet" class="ml-4 my-0">
        <template v-slot:label>
          <span style="font-size: 0.8rem;">Казгидромет: 16</span>
        </template>
      </v-checkbox>
    </v-row>

      <v-sheet
        id="scrolling-techniques-7"
        class="overflow-x-hidden"
        max-height="87vh"
      >
        <v-row dense>
          <v-col align="center" justify="center">
            <vl-map
              data-projection="EPSG:4326"
              style="width: 100%; height: 100vh;"
              ref="map"
              @moveend="onMoveEnd"
              @pointermove="onMapPointerMove"
              :style="{ cursor: mapCursor }"
            >
              <vl-view :zoom.sync="zoom" :center.sync="center"></vl-view>

              <vl-geoloc
                v-if="$store.state.settings.gps"
                @update:position="geolocPosition = $event"
              >
                <template slot-scope="geoloc">
                  <vl-feature v-if="geoloc.position" id="position-feature">
                    <vl-geom-point
                      :coordinates="geoloc.position"
                    ></vl-geom-point>
                    <vl-style-func :factory="gpsStyle" />
                  </vl-feature>
                </template>
              </vl-geoloc>

              <vl-layer-tile
                v-for="(item, index) in $store.state.settings.maps"
                :z-index="index"
                :opacity="item.alpha / 100"
                :key="item.id"
              >
                <vl-source-osm
                  v-if="(item.id === 'osm') & item.visible"
                ></vl-source-osm>
                <vl-source-xyz
                  v-if="(item.id === '2gis') & item.visible"
                  url="http://tile0.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1&ts=online_sd"
                ></vl-source-xyz>
                <vl-source-bingmaps
                  v-if="(item.id === 'bingMapsAerial') & item.visible"
                  :api-key="$store.state.settings.apiKeyBing"
                  imagery-set="Aerial"
                ></vl-source-bingmaps>
                <vl-source-bingmaps
                  v-if="(item.id === 'bingMapsAerialWithLabels') & item.visible"
                  :api-key="$store.state.settings.apiKeyBing"
                  imagery-set="Aerial"
                ></vl-source-bingmaps>
                <vl-source-xyz
                  v-if="(item.id === 'mapbox') & item.visible"
                  url="https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZGFnb3QiLCJhIjoiY2lveTNjbnRnMDBjOXZtbTJqNGNsNmk1NCJ9.bvTUlzXKG4A2ZejsF1v2Hw"
                ></vl-source-xyz>
                <vl-source-xyz
                  v-if="(item.id === 'arcgis') & item.visible"
                  url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                  :tile-load-function="arcgisLoad"
                ></vl-source-xyz>
                <vl-source-xyz
                  v-if="(item.id === 'agp') & item.visible"
                  url="https://api.eco-almaty.kz/tiles/agp/{z}/{x}/{-y}.png"
                ></vl-source-xyz>
              </vl-layer-tile>

              <vl-layer-vector
                :min-resolution="15.1"
                :z-index="100"
                v-if="$store.state.user.userRole !== 3"
                :key="layerDistrictUpdate"
              >
                <vl-source-vector :loader="getDistrictsData" />
                <vl-style-func :factory="districtStyle" />
              </vl-layer-vector>

              <vl-layer-vector
                ref="layerCluster"
                :min-resolution="6"
                :max-resolution="15"
                v-if="$store.state.user.userRole !== 3"
                :key="layerClusterUpdate"
              >
                <vl-source-vector :loader="getClusterGrid" />
                <vl-style-func :factory="styleFunction" />
              </vl-layer-vector>

              <vl-layer-vector id="layerTaxator" :z-index="100" v-else>
                <vl-source-vector
                  :loader="getCurrentTaxatorGrid"
                  ref="taxatorSource"
                />
              </vl-layer-vector>

              <vl-interaction-select
                v-if="$store.state.user.userRole !== 3 && showComment"
                :features.sync="selectedFeaturesComment"
                :layers="['layerComment']"
                @select="onSelectComment"
                ident="featuresCommentSelected"
                ref="selectComment"
              />
              <vl-layer-vector id="layerDrawComment" :z-index="998">
                <vl-source-vector
                  :features.sync="drawFeaturesComment"
                  ident="featuresCommentDraw"
                ></vl-source-vector>
              </vl-layer-vector>
              <vl-interaction-draw
                v-if="isComment"
                type="Point"
                source="featuresCommentDraw"
                @drawend="drawEndComment"
                stop-click
              />

              <vl-layer-vector id="layerAPI" :z-index="101">
                <vl-source-vector
                  :features.sync="features"
                  ident="featuresAPI"
                  ref="vectorSource"
                />
                <PlantStyle />
              </vl-layer-vector>

              <vl-layer-vector id="layerDraw" :z-index="102">
                <vl-source-vector
                  :features.sync="drawFeatures"
                  ident="featuresDraw"
                ></vl-source-vector>
              </vl-layer-vector>
              <vl-interaction-draw
                v-if="typeTarget.id && isDraw"
                :type="typeTarget.geometry_type"
                source="featuresDraw"
                @drawend="drawEnd"
                stop-click
              />
              <vl-interaction-select
                :features.sync="selectedFeatures"
                :layers="['layerAPI', 'layerDraw', 'layerGroup']"
                @select="onSelect"
                @unselect="onUnselect"
                ident="featuresSelected"
                ref="select"
              />
              <vl-interaction-translate
                source="featuresSelected"
                @translateend="translateEndGroup"
              />

              <vl-layer-vector id="layerGroup" :z-index="103">
                <vl-source-vector
                  :features.sync="drawGroupFeatures"
                  ident="groupDraw"
                ></vl-source-vector>
              </vl-layer-vector>
              <vl-interaction-draw
                v-if="selectedGroup"
                type="Polygon"
                source="groupDraw"
                @drawstart="drawStartGroup"
                @drawend="drawEndGroup"
                stop-click
              />

              <vl-layer-vector id="layerReportDraw" :z-index="104">
                <vl-source-vector
                  :features.sync="drawReportFeatures"
                  ident="reportDraw"
                ></vl-source-vector>
              </vl-layer-vector>
              <vl-interaction-draw
                v-if="selectionObj"
                type="Polygon"
                source="reportDraw"
                @drawstart="drawStartReport"
                @drawend="drawEndReport"
                stop-click
              />
              <vl-interaction-select
                :features.sync="selectedReportFeatures"
                :layers="['layerReportDraw']"
                ident="featuresReportSelected"
                @select="onReportSelect"
                @unselect="onReportUnselect"
                ref="selectReport"
              />

              <vl-layer-vector id="layerLength" :z-index="105">
                <vl-source-vector
                  :features.sync="distanceFeatures"
                  ident="lengthDraw"
                />
                <vl-style-func :factory="measureFeaturesStyle" />
              </vl-layer-vector>
              <vl-interaction-draw
                v-if="distance"
                type="LineString"
                source="lengthDraw"
                @drawstart="drawStartLength"
                @drawend="drawEndLength"
                stop-click
              >
                <vl-style-func :factory="measureDrawStyle" />
              </vl-interaction-draw>

              <vl-layer-vector id="layerArea" :z-index="106">
                <vl-source-vector
                  :features.sync="areaFeatures"
                  ident="areaDraw"
                />
                <vl-style-func :factory="measureFeaturesStyle" />
              </vl-layer-vector>
              <vl-interaction-draw
                v-if="area"
                type="Polygon"
                source="areaDraw"
                @drawstart="drawStartLength"
                @drawend="drawEndLength"
                stop-click
              >
                <vl-style-func :factory="measureDrawStyle" />
              </vl-interaction-draw>

              <vl-layer-vector v-if="clarity" id="layerAirClarity" :z-index="107">
                <vl-source-vector :features.sync="clarities" ident="air">
                  <vl-style-func :factory="airFeaturesStyle" />
                </vl-source-vector>
              </vl-layer-vector>

              <vl-layer-vector v-if="icmaos" id="layerAirEcos" :z-index="108">
                <vl-source-vector :features.sync="ecos" ident="airEcos">
                  <vl-style-func :factory="airFeaturesStyleSmarteco" />
                </vl-source-vector>
              </vl-layer-vector>

              <vl-layer-vector v-if="gidromet" id="layerAirKazgidromet" :z-index="109">
                <vl-source-vector :features.sync="kazgidromet" ident="airKazgidromet">
                  <vl-style-func :factory="airFeaturesStyleKazgidromet" />
                </vl-source-vector>
              </vl-layer-vector>

              <vl-interaction-select
                :features.sync="selectedClarities"
                :layers="['layerAirClarity']"
                ident="featuresAirSelectedClarity"
                @select="onAirSelect('clarity')"
                @unselect="onAirUnselect"
                ref="selectAirClarity"
              />
              <vl-interaction-select
                :features.sync="selectedSmarteco"
                :layers="['layerAirEcos']"
                ident="featuresAirSelectedSmarteco"
                @select="onAirSelect('smarteco')"
                @unselect="onAirUnselect"
                ref="selectAirSmarteco"
              />
              <vl-interaction-select
                :features.sync="selectedKazgidromet"
                :layers="['layerAirKazgidromet']"
                ident="featuresAirSelectedKazgidromet"
                @select="onAirSelect('kazgidromet')"
                @unselect="onAirUnselect"
                ref="selectAirKazgidromet"
              />


              <vl-overlay
                :position="breedPosition"
                positioning="center-left"
                :offset="[15, 0]"
              >
                <div class="ol-tooltip">
                  {{ breedName }}
                </div>
              </vl-overlay>
            </vl-map>
          </v-col>
          <AirPassportClarity
            v-if="selectedClarities.length > 0 && passportAir"
            :properties="propertiesAir"
            :geoCoordinates="geoCoordinates"
            :isDraw="isDraw"
          />
          <AirPassportSmarteco
            v-if="selectedSmarteco.length > 0 && passportAir"
            :properties="propertiesAir"
            :isDraw="isDraw"
          />
          <AirPassportKazgidromet
            v-if="selectedKazgidromet.length > 0 && passportAir"
            :properties="propertiesAir"
            :isDraw="isDraw"
          />

          <CommentPassport
            v-if="selectedFeaturesComment.length > 0"
            :setComment="setComment"
            :properties="propertiesComment"
            :isDraw="isDraw"
            @remove-comment="removeComment"
          />
          <TreePassport
            v-if="typeTarget.id === 1 && passport"
            :setPlants="setPlants"
            :properties="properties"
            :geoCoordinates="geoCoordinates"
            :isDraw="isDraw"
            :district="district"
            @remove-plant="removePlants"
          />
          <BushPassport
            v-if="typeTarget.id === 2 && passport"
            :setPlants="setPlants"
            :properties="properties"
            :geoCoordinates="geoCoordinates"
            :isDraw="isDraw"
            :district="district"
            @remove-plant="removePlants"
          />
          <CurtainTreePassport
            v-if="typeTarget.id === 3 && passport"
            :setPlants="setPlants"
            :properties="properties"
            :isDraw="isDraw"
            :district="district"
            @remove-plant="removePlants"
          />
          <CurtainBushPassport
            v-if="typeTarget.id === 4 && passport"
            :setPlants="setPlants"
            :properties="properties"
            :isDraw="isDraw"
            :district="district"
            @remove-plant="removePlants"
          />
          <HedgePassport
            v-if="typeTarget.id === 5 && passport"
            :setPlants="setPlants"
            :properties="properties"
            :isDraw="isDraw"
            :district="district"
            @remove-plant="removePlants"
          />
          <FlowerGardenPassport
            v-if="typeTarget.id === 6 && passport"
            :setPlants="setPlants"
            :properties="properties"
            :isDraw="isDraw"
            :district="district"
            @remove-plant="removePlants"
          />
          <LawnPassport
            v-if="typeTarget.id === 7 && passport"
            :setPlants="setPlants"
            :properties="properties"
            :isDraw="isDraw"
            :district="district"
            @remove-plant="removePlants"
          />
          <VinesPassport
            v-if="typeTarget.id === 8 && passport"
            :setPlants="setPlants"
            :properties="properties"
            :isDraw="isDraw"
            :district="district"
            @remove-plant="removePlants"
          />
          <ReportPassport
            v-if="selectionObj && reportPassport"
            :selectedObjReport="selectedObjReport"
            :reportCount="reportCount"
          />
        </v-row>
      </v-sheet>

      <Filters
        v-show="drawerFilter"
        @close-filters="drawerFilter = !drawerFilter"
        :updateDistricts="updateDistricts"
        :updateClusters="updateClusters"
        @filter-message="filterMsg"
      />
      <v-card>
        <v-snackbar v-model="snackbar" :timeout="timeout" top right outlined>
          {{ text }}
          <template v-slot:action="{ attrs }">
            <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
              Закрыть
            </v-btn>
          </template>
        </v-snackbar>
      </v-card>
  </v-container>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

import WKT from "ol/format/WKT";
import GeoJSON from "ol/format/GeoJSON";
import { fromExtent } from "ol/geom/Polygon";
import * as olExt from "vuelayers/dist/ol-ext";
import {Fill, Text, Stroke, Style, Circle as CircleStyle, Icon} from "ol/style";
import { fromLonLat } from "ol/proj";
import Polygon from "ol/geom/Polygon";
import LineString from "ol/geom/LineString";
import TileState from "ol/TileState";

import CommentPassport from "../passports/CommentPassport";
import TreePassport from "../passports/TreePassport.vue";
import BushPassport from "../passports/BushPassport.vue";
import CurtainTreePassport from "../passports/CurtainTreePassport.vue";
import CurtainBushPassport from "../passports/CurtainBushPassport.vue";
import FlowerGardenPassport from "../passports/FlowerGardenPassport.vue";
import LawnPassport from "../passports/LawnPassport.vue";
import HedgePassport from "../passports/HedgePassport.vue";
import VinesPassport from "../passports/VinesPassport.vue";
import ReportPassport from "../passports/ReportPassport.vue";
import Filters from "@/components/tools/Filters.vue";
import { URL_API } from "../settings/apiConnect";
import PlantStyle from "@/components/PlantStyle.vue";
import markerImg from "@/assets/marker.png";
import { getLength, getArea } from "ol/sphere";
import AirPassportClarity from "@/passports/AirPassportClarity.vue";
import AirPassportSmarteco from "@/passports/AirPassportSmarteco.vue";
import AirPassportKazgidromet from "@/passports/AirPassportKazgidromet.vue";

import airImgGray from "@/assets/air_empty.svg";
import airImgGreen from "@/assets/air_green.svg";
import airImgYellow from "@/assets/air_yellow.svg";
import airImgOrange from "@/assets/air_orange.svg";
import airImgRed from "@/assets/air_red.svg";
import airImgPurple from "@/assets/air_purple.svg";
import airImgBurgundy from "@/assets/air_burgundy.svg";

export default {
  name: "MapTab3",

  data() {
    return {
      zoom: 13,
      center: [76.889709, 43.238949],

      clarity: true,
      icmaos: true,
      gidromet: true,

      geolocPosition: undefined,
      formatWKT: new WKT(),
      formatGeoJSON: new GeoJSON(),
      typeTarget: { id: 0, name: "РЕДАКТИРОВАНИЕ", geometry_type: "Point" },
      features: [],
      drawFeatures: [],
      drawFeaturesComment: [],
      selectedFeatures: [],
      selectedFeaturesComment: [],
      drawGroupFeatures: [],
      drawReportFeatures: [],
      selectedReportFeatures: [],
      distanceFeatures: [],
      areaFeatures: [],
      geometries: { plants: [] },
      reportGeometry: null,
      reportCount: [],
      taxatorgrid: [],
      passport: false,
      reportPassport: false,
      properties: {},
      propertiesComment: {},
      propertiesAir: {},
      geoCoordinates: {},
      district: {},
      cancelToken: null,
      snackbar: false,
      text: "",
      timeout: 2000,
      isComment: false,
      isDraw: false,
      editObj: false,
      selectedGroup: false,
      selectionObj: false,
      distance: false,
      area: false,
      drawerFilter: false,
      searchID: null,
      breedPosition: undefined,
      breedName: undefined,
      curBreedId: undefined,
      lstBreedId: undefined,
      mapCursor: "default",
      tooltipHide: "",
      sketch: null,
      listener: null,
      layerDistrictUpdate: 0,
      layerClusterUpdate: 10000,
      startCopy: false,

      clarities: [],
      ecos: [],
      kazgidromet: [],
      selectedClarities: [],
      selectedSmarteco: [],
      selectedKazgidromet: [],
      passportAir: false,
    };
  },

  computed: {
    ...mapGetters(["allLayersData"]),
    layerTarget: {
      get() {
        return this.$store.state.settings.layerTarget;
      },
      set(value) {
        this.$store.commit("updateLayerTarget", value);
      }
    },
    types() {
      return this.$store.state.types.typesData;
    },
    layers() {
      let arr = [];
      if (
        this.$store.state.user.userRole === 4 ||
        this.$store.state.user.userRole === 5
      ) {
        this.allLayersData.filter(el => {
          if (el.id === 0) arr.push(el);
        });
        return arr;
      } else {
        return this.allLayersData;
      }
    },
    showComment: {
      get() {
        return !this.$store.state.settings.commentHide;
      },
      set(value) {
        this.$store.commit("setFiltredComment", value);
      }
    }
  },

  watch: {
    layerTarget: function() {
      this.onMoveEnd();
      this.layerDistrictUpdate++;
      this.layerClusterUpdate++;
    }
  },

  methods: {
    ...mapActions([
      "getCurrentTaxatorGrid",
      "getPlantById",
      "createPlantData",
      "pushPlantData",
      "destroyPlantData",
      "getDistrictByArea",
      "pushPlantGeometries",
      "createComment",
      "pushComment",
      "destroyComment",
      "getDistrictsData",
      "getClusterGrid",
    ]),

    districtStyle() {
      return () => {
        let baseStyle = new Style({
          stroke: new Stroke({
            color: "rgba(0,0,255, 1)",
            width: 2
          }),
        });
        return [baseStyle];
      };
    },
    styleFunction() {
      return () => {
        let baseStyle = new Style({
          stroke: new Stroke({
            color: "rgba(0,0,255, 1)",
            width: 1
          }),
        });
        return [baseStyle];
      };
    },

    arcgisLoad(imageTile, src) {
      let map = this.$refs.map;
      let zoom = map.getView().getZoom();
      if (zoom > 19) {
        imageTile.setState(TileState.ERROR);
      } else {
        imageTile.getImage().src = src;
      }
    },

    airFeaturesStyle() {
      return feature => {
        const characteristics = feature.get("characteristics");

        let src = airImgGray;
        const pm2_5Value = characteristics.pm2_5ConcMass?.value;
        if (pm2_5Value) {
          if (pm2_5Value <= 12.0) {
            src = airImgGreen; // Хорошо
          } else if (pm2_5Value > 12.0 && pm2_5Value <= 35.4) {
            src = airImgYellow; // Умеренно
          } else if (pm2_5Value > 35.4 && pm2_5Value <= 55.4) {
            src = airImgOrange; // Нездоровый для чувствительных групп
          } else if (pm2_5Value > 55.4 && pm2_5Value <= 150.4) {
            src = airImgRed; // Нездоровый
          } else if (pm2_5Value > 150.4 && pm2_5Value <= 250.4) {
            src = airImgPurple; // Очень нездоровый
          } else if (pm2_5Value > 250.4) {
            src = airImgBurgundy; // Опасно
          }
        }

        return [
          new Style({
            image: new Icon({
              src: src,
              anchor: [0.5, 1]
            }),
            text: new Text({
              text: String(characteristics.pm2_5NowCastAqi?.value),
              offsetY: -25
            })
          })
        ];
      };
    },

    airFeaturesStyleSmarteco() {
      return feature => {
        const pm2_5Value = feature.get("pm25") * 1000;

        let src = airImgGray;
        if (pm2_5Value) {
          if (pm2_5Value <= 12.0) {
            src = airImgGreen; // Хорошо
          } else if (pm2_5Value > 12.0 && pm2_5Value <= 35.4) {
            src = airImgYellow; // Умеренно
          } else if (pm2_5Value > 35.4 && pm2_5Value <= 55.4) {
            src = airImgOrange; // Нездоровый для чувствительных групп
          } else if (pm2_5Value > 55.4 && pm2_5Value <= 150.4) {
            src = airImgRed; // Нездоровый
          } else if (pm2_5Value > 150.4 && pm2_5Value <= 250.4) {
            src = airImgPurple; // Очень нездоровый
          } else if (pm2_5Value > 250.4) {
            src = airImgBurgundy; // Опасно
          }
        }

        return [
          new Style({
            image: new Icon({
              src: src,
              anchor: [0.5, 1]
            })
          })
        ];
      };
    },

    airFeaturesStyleKazgidromet() {
      return feature => {
        const pm2_5Value = feature.get("pm25") * 1000;

        let src = airImgGray;
        if (pm2_5Value) {
          if (pm2_5Value <= 12.0) {
            src = airImgGreen; // Хорошо
          } else if (pm2_5Value > 12.0 && pm2_5Value <= 35.4) {
            src = airImgYellow; // Умеренно
          } else if (pm2_5Value > 35.4 && pm2_5Value <= 55.4) {
            src = airImgOrange; // Нездоровый для чувствительных групп
          } else if (pm2_5Value > 55.4 && pm2_5Value <= 150.4) {
            src = airImgRed; // Нездоровый
          } else if (pm2_5Value > 150.4 && pm2_5Value <= 250.4) {
            src = airImgPurple; // Очень нездоровый
          } else if (pm2_5Value > 250.4) {
            src = airImgBurgundy; // Опасно
          }
        }

        return [
          new Style({
            image: new Icon({
              src: src,
              anchor: [0.5, 1]
            })
          })
        ];
      };
    },

    measureFeaturesStyle() {
      return () => {
        let baseStyle = new Style({
          fill: new Fill({
            color: "rgba(255, 255, 255, 0.2)"
          }),
          stroke: new Stroke({
            color: "#ffcc33",
            width: 2
          }),
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({
              color: "#ffcc33"
            })
          })
        });
        return [baseStyle];
      };
    },

    measureDrawStyle() {
      return () => {
        let baseStyle = new Style({
          fill: new Fill({
            color: "rgba(255, 255, 255, 0.2)"
          }),
          stroke: new Stroke({
            color: "rgba(0, 0, 0, 0.5)",
            lineDash: [10, 10],
            width: 2
          }),
          image: new CircleStyle({
            radius: 5,
            stroke: new Stroke({
              color: "rgba(0, 0, 0, 0.7)"
            }),
            fill: new Fill({
              color: "rgba(255, 255, 255, 0.2)"
            })
          })
        });
        return [baseStyle];
      };
    },

    gpsStyle() {
      return () => {
        return [
          new Style({
            image: new Icon({
              src: markerImg
            })
          })
        ];
      };
    },

    onMoveEnd() {
/*      this.selectedFeatures = [];
      this.calcViewPolygon();*/
    },

    async calcViewPolygon() {
      let map = this.$refs.map;
      let zoom = map.getView().getZoom();
      if (zoom > 18) {
        let size = await map.getSize();
        let extent = map.getView().calculateExtent(size);
        let sourceProj = map.getView().getProjection();
        let s = fromExtent(extent).transform(sourceProj, "EPSG:4326");
        let wkt = this.formatWKT.writeGeometry(s);
        let districts = "";
        if (this.$store.state.settings.ids_districts)
          districts = `district_id=${this.$store.state.settings.ids_districts}&`;
        let types = "";
        if (this.$store.state.settings.ids_types)
          types = `type_id=${this.$store.state.settings.ids_types}&`;
        let breeds = "";
        if (this.$store.state.settings.ids_breeds)
          breeds = `breed_id=${this.$store.state.settings.ids_breeds}&`;
        let sanitary = "";
        if (this.$store.state.settings.ids_sanitary)
          sanitary = `sanitary_id=${this.$store.state.settings.ids_sanitary}&`;
        let statuses = "";
        if (this.$store.state.settings.ids_statuses)
          statuses = `status_id=${this.$store.state.settings.ids_statuses}&`;
        let events = "";
        if (this.$store.state.settings.ids_events)
          events = `event_id=${this.$store.state.settings.ids_events}&`;
        let vermin = "";
        if (this.$store.state.settings.ids_vermin)
          vermin = `vermin_id=${this.$store.state.settings.ids_vermin}&`;
        let diseases = "";
        if (this.$store.state.settings.ids_diseases)
          diseases = `disease_id=${this.$store.state.settings.ids_diseases}&`;
        let redbook = "";
        if (this.$store.state.settings.redbookTarget)
          redbook = `redbook=${this.$store.state.settings.redbookTarget}&`;
        let layer = "";
        if (this.$store.state.settings.layerTarget !== 0)
          layer = `layer_id=${this.$store.state.settings.layerTarget}&`;

        if (this.cancelToken) {
          this.cancelToken.cancel();
        }
        this.cancelToken = Vue.axios.CancelToken.source();
        try {
          let response;
          if (this.$store.state.user.userRole === 5) {
            response = await Vue.axios.get(
              `${URL_API}plant/getbyfilter?district_id=${this.$store.state.user.currentUser.district_id}&${types}${sanitary}${statuses}${events}${vermin}${diseases}${redbook}${layer}&geometry=${wkt}`,
              { cancelToken: this.cancelToken.token }
            );
          } else {
            response = await Vue.axios.get(
              `${URL_API}plant/getbyfilter?${districts}${types}${breeds}${sanitary}${statuses}${events}${vermin}${diseases}${redbook}${layer}&geometry=${wkt}`,
              { cancelToken: this.cancelToken.token }
            );
          }

          let data = response["data"];
          this.features = [];
          this.features = data.features;

          setTimeout(() => {
            if (this.searchID !== undefined) {
              const id = this.searchID;
              const source = this.$refs.vectorSource.$source;
              source.forEachFeature(feature => {
                if (feature.get("id") == id) {
                  let feature1 = olExt.writeGeoJsonFeature(feature);
                  this.selectedFeatures.push(feature1);
                  this.editObj = true;
                  this.searchID = null;
                  return;
                }
              });
            }
          }, 2000);
        } catch (error) {
          console.log(error);
        }
      } else if (zoom >= 14.9 && zoom <= 18) {
        let size = await map.getSize();
        let extent = map.getView().calculateExtent(size);
        let sourceProj = map.getView().getProjection();
        let s = fromExtent(extent).transform(sourceProj, "EPSG:4326");
        let wkt = this.formatWKT.writeGeometry(s);
        let districts = "";
        if (this.$store.state.settings.ids_districts)
          districts = `district_id=${this.$store.state.settings.ids_districts}&`;
        let types = "";
        if (this.$store.state.settings.ids_types)
          types = `type_id=${this.$store.state.settings.ids_types}&`;
        let breeds = "";
        if (this.$store.state.settings.ids_breeds)
          breeds = `breed_id=${this.$store.state.settings.ids_breeds}&`;
        let sanitary = "";
        if (this.$store.state.settings.ids_sanitary)
          sanitary = `sanitary_id=${this.$store.state.settings.ids_sanitary}&`;
        let statuses = "";
        if (this.$store.state.settings.ids_statuses)
          statuses = `status_id=${this.$store.state.settings.ids_statuses}&`;
        let events = "";
        if (this.$store.state.settings.ids_events)
          events = `event_id=${this.$store.state.settings.ids_events}&`;
        let vermin = "";
        if (this.$store.state.settings.ids_vermin)
          vermin = `vermin_id=${this.$store.state.settings.ids_vermin}&`;
        let diseases = "";
        if (this.$store.state.settings.ids_diseases)
          diseases = `disease_id=${this.$store.state.settings.ids_diseases}&`;
        let redbook = "";
        if (this.$store.state.settings.redbookTarget)
          redbook = `redbook=${this.$store.state.settings.redbookTarget}&`;
        let layer = "";
        if (this.$store.state.settings.layerTarget !== 0)
          layer = `layer_id=${this.$store.state.settings.layerTarget}&`;

        if (this.cancelToken) {
          this.cancelToken.cancel();
        }
        this.cancelToken = Vue.axios.CancelToken.source();

        try {
          if (
            types.indexOf("1") > 0 ||
            types.indexOf("2") > 0 ||
            types.indexOf("6") > 0
          ) {
            return;
          }
          if (this.$store.state.settings.ids_types === "") {
            types = `type_id=3,4,5,7,8&`;
          }
          let response;
          if (this.$store.state.user.userRole === 5) {
            response = await Vue.axios.get(
              `${URL_API}plant/getbyfilter?district_id=${this.$store.state.user.currentUser.district_id}&${types}${sanitary}${statuses}${events}${vermin}${diseases}${redbook}${layer}&geometry=${wkt}`,
              { cancelToken: this.cancelToken.token }
            );
          } else {
            response = await Vue.axios.get(
              `${URL_API}plant/getbyfilter?${districts}${types}${breeds}${sanitary}${statuses}${events}${vermin}${diseases}${redbook}${layer}&geometry=${wkt}`,
              { cancelToken: this.cancelToken.token }
            );
          }

          let data = response["data"];
          this.features = [];
          this.features = data.features;

          setTimeout(() => {
            if (this.searchID !== undefined) {
              const id = this.searchID;
              const source = this.$refs.vectorSource.$source;
              source.forEachFeature(feature => {
                if (feature.get("id") == id) {
                  let feature1 = olExt.writeGeoJsonFeature(feature);
                  this.selectedFeatures.push(feature1);
                  this.editObj = true;
                  this.searchID = null;
                  return;
                }
              });
            }
          }, 2000);
        } catch (error) {
          console.log(error);
        }
      } else {
        this.features = [];
      }
    },

    async updateDistricts() {
      this.layerDistrictUpdate++;
    },

    async updateClusters() {
      this.layerClusterUpdate++;
    },

    async getDistrictQuantity() {
      let districts = "";
      if (this.$store.state.settings.ids_districts)
        districts = `district_id=${this.$store.state.settings.ids_districts}&`;
      let types = "";
      if (this.$store.state.settings.ids_types)
        types = `type_id=${this.$store.state.settings.ids_types}&`;
      let breeds = "";
      if (this.$store.state.settings.ids_breeds)
        breeds = `breed_id=${this.$store.state.settings.ids_breeds}&`;
      let sanitary = "";
      if (this.$store.state.settings.ids_sanitary)
        sanitary = `sanitary_id=${this.$store.state.settings.ids_sanitary}&`;
      let statuses = "";
      if (this.$store.state.settings.ids_statuses)
        statuses = `status_id=${this.$store.state.settings.ids_statuses}&`;
      let events = "";
      if (this.$store.state.settings.ids_events)
        events = `event_id=${this.$store.state.settings.ids_events}&`;
      let vermin = "";
      if (this.$store.state.settings.ids_vermin)
        vermin = `vermin_id=${this.$store.state.settings.ids_vermin}&`;
      let diseases = "";
      if (this.$store.state.settings.ids_diseases)
        diseases = `disease_id=${this.$store.state.settings.ids_diseases}&`;
      let redbook = "";
      if (this.$store.state.settings.redbookTarget)
        redbook = `redbook=${this.$store.state.settings.redbookTarget}&`;
      let layer = "";
      if (this.$store.state.settings.layerTarget !== 0)
        layer = `layer_id=${this.$store.state.settings.layerTarget}&`;
      let response;
      response = await Vue.axios.get(
        `${URL_API}district/getbyfilter?${districts}${types}${breeds}${sanitary}${statuses}${events}${vermin}${diseases}${redbook}${layer}`
      );
      let data = response["data"];
      return data;
    },

    async getClusterQuantity() {
      let districts = "";
      if (this.$store.state.settings.ids_districts)
        districts = `district_id=${this.$store.state.settings.ids_districts}&`;
      let types = "";
      if (this.$store.state.settings.ids_types)
        types = `type_id=${this.$store.state.settings.ids_types}&`;
      let breeds = "";
      if (this.$store.state.settings.ids_breeds)
        breeds = `breed_id=${this.$store.state.settings.ids_breeds}&`;
      let sanitary = "";
      if (this.$store.state.settings.ids_sanitary)
        sanitary = `sanitary_id=${this.$store.state.settings.ids_sanitary}&`;
      let statuses = "";
      if (this.$store.state.settings.ids_statuses)
        statuses = `status_id=${this.$store.state.settings.ids_statuses}&`;
      let events = "";
      if (this.$store.state.settings.ids_events)
        events = `event_id=${this.$store.state.settings.ids_events}&`;
      let vermin = "";
      if (this.$store.state.settings.ids_vermin)
        vermin = `vermin_id=${this.$store.state.settings.ids_vermin}&`;
      let diseases = "";
      if (this.$store.state.settings.ids_diseases)
        diseases = `disease_id=${this.$store.state.settings.ids_diseases}&`;
      let redbook = "";
      if (this.$store.state.settings.redbookTarget)
        redbook = `redbook=${this.$store.state.settings.redbookTarget}&`;
      let layer = "";
      if (this.$store.state.settings.layerTarget !== 0)
        layer = `layer_id=${this.$store.state.settings.layerTarget}&`;
      let response;
      response = await Vue.axios.get(
        `${URL_API}clustergrid/getbyfilter?${districts}${types}${breeds}${sanitary}${statuses}${events}${vermin}${diseases}${redbook}${layer}`
      );
      let data = response["data"];
      return data;
    },

    drawStartGroup() {
      this.selectedFeatures = [];
      this.drawGroupFeatures = [];
    },

    drawEndGroup(e) {
      const geometry = e.feature.getGeometry();
      const extent = e.feature.getGeometry().getExtent();
      const source = this.$refs.vectorSource.$source;
      source.forEachFeatureIntersectingExtent(extent, feature => {
        const coordinate = feature.getGeometry().getCoordinates();
        const type = feature.getGeometry().getType();
        if (type === "Point") {
          if (geometry.intersectsCoordinate(coordinate)) {
            feature = olExt.writeGeoJsonFeature(feature);
            this.selectedFeatures.push(feature);
          }
        } else if (type === "Polygon") {
          for (let el of coordinate[0]) {
            if (geometry.intersectsCoordinate(el)) {
              feature = olExt.writeGeoJsonFeature(feature);
              this.selectedFeatures.push(feature);
              return;
            }
          }
        } else if (type === "LineString") {
          for (let el of coordinate) {
            if (geometry.intersectsCoordinate(el)) {
              feature = olExt.writeGeoJsonFeature(feature);
              this.selectedFeatures.push(feature);
              return;
            }
          }
        }
      });
      this.drawGroupFeatures = [];
    },

    translateEndGroup(value) {
      this.drawGroupFeatures = [];
      this.geometries = { plants: [] };
      value.json.forEach(fe => {
        let geometry = this.formatGeoJSON.readFeature(fe.geometry);
        let wkt = this.formatWKT.writeFeature(geometry);
        this.geometries.plants.push({ id: fe.properties.id, geometry: wkt });
      });
    },

    async copyGroup() {
      if (!this.startCopy) {
        this.startCopy = true;
        this.selectedGroup = !this.selectedGroup;
        if (this.selectedFeatures.length > 1) {
          let clone = this.selectedFeatures.map(obj => ({ ...obj }));
          this.selectedFeatures = [];
          clone.forEach(element => {
            this.drawFeatures.push(element);
          });
          this.selectedFeatures = this.drawFeatures;
        }
      } else {
        let next = confirm("Вы хотите отменить копирование группы?");
        if (next) {
          this.startCopy = false;
          this.drawFeatures = [];
          this.selectedFeatures = [];
          this.onMoveEnd();
        }
      }
    },

    async saveGroup() {
      this.selectedGroup = !this.selectedGroup;
      if (this.selectedFeatures.length > 1) {
        if (this.drawFeatures.length > 1) {
          let nextCopy = confirm(
            "Вы действительно хотите сохранить копию группы?"
          );
          if (nextCopy) {
            while (this.selectedFeatures.length !== 0) {
              let properties = await this.getPlantById(this.selectedFeatures[0].properties.id);
              this.typeTarget = this.types.find(e => {
                return e.id === properties.type_id;
              });
              await this.setPlants(properties);
              this.selectedFeatures.shift();
              this.geometries.plants.shift();
            }
            this.selectedGroup = false;
            this.startCopy = false;
            this.drawFeatures = [];
            this.onMoveEnd();
            return;
          } else {
            return;
          }
        }

        let next = confirm(
          "Вы действительно хотите сохранить перемещение группы?"
        );
        if (next) {
          await this.pushPlantGeometries(this.geometries);
          this.selectedFeatures = [];
          this.calcViewPolygon();
          this.selectedGroup = false;
        }
      }
      this.selectedFeatures = [];
    },

    async deleteGroup() {
      let next = confirm(
          "Вы действительно хотите удалить группу?"
      );
      if (next) {
        while (this.selectedFeatures.length !== 0) {
          this.removePlants();
          this.selectedFeatures.shift();
        }
        this.geometries = { plants: [] };
        this.onMoveEnd();
      }
    },

    async setComment({ comment }) {
      let feature = this.formatGeoJSON.readFeature(
        this.selectedFeaturesComment[0]
      );
      let wktRepresenation = this.formatWKT.writeFeature(feature);
      let properties = this.selectedFeaturesComment[0].properties;
      if (properties) {
        await this.pushComment({
          id: properties.id,
          geometry: wktRepresenation,
          comment: comment,
          user_id: this.$store.state.user.currentUser.id
        });
      } else {
        await this.createComment({
          geometry: wktRepresenation,
          comment: comment,
          user_id: this.$store.state.user.currentUser.id
        });
      }
      this.showComment = true;
      setTimeout(() => {
        this.drawFeaturesComment = [];
        this.selectedFeaturesComment = [];
        this.showComment = false;
        this.text = this.$store.state.message.msg;
        this.snackbar = true;
      }, 1);
    },

    async removeComment() {
      let properties = this.selectedFeaturesComment[0].properties;
      if (!properties) {
        this.drawFeaturesComment = this.drawFeaturesComment.filter(
          item =>
            !(
              JSON.stringify(item.geometry) ===
              JSON.stringify(this.selectedFeaturesComment[0].geometry)
            )
        );
        return;
      } else {
        await this.destroyComment(properties.id);
      }
      this.showComment = true;
      setTimeout(() => {
        this.drawFeaturesComment = [];
        this.selectedFeaturesComment = [];
        this.showComment = false;
        this.text = this.$store.state.message.msg;
        this.snackbar = true;
      }, 1);
    },

    async setPlants({
      age,
      height,
      diameter,
      serial_number,
      sanitary_id,
      category_id,
      status_id,
      in_charge,
      planting_date,
      registry_date,
      quantity,
      length,
      area,
      vermin,
      diseases,
      events,
      breeds,
      lawn_name,
      lawn_type,
      bushes,
      vines,
      flower_garden_id,
      flowers,
      image
    }) {
      let feature;
      let wktRepresenation;
      if (this.geometries.plants.length > 0) {
        wktRepresenation = this.geometries.plants[0].geometry;
      } else {
        feature = this.formatGeoJSON.readFeature(this.selectedFeatures[0]);
        wktRepresenation = this.formatWKT.writeFeature(feature);
      }

      if(this.startCopy) {
        this.district = await this.getDistrictByArea(wktRepresenation);
        this.createPlantData({
          geometry: wktRepresenation,
          layer_id: this.layerTarget,
          age: age,
          height: height,
          diameter: diameter,
          serial_number: serial_number,
          sanitary_id: sanitary_id,
          category_id: category_id,
          status_id: status_id,
          district_id: this.district.id,
          in_charge: in_charge,
          planting_date: planting_date,
          registry_date: registry_date,
          quantity: quantity,
          length: length,
          area: area,
          vermin: vermin,
          diseases: diseases,
          events: events,
          type_id: this.typeTarget.id,
          breeds: breeds && breeds[0] ? [breeds[0].id] : undefined,
          lawn_name: lawn_name,
          lawn_type: lawn_type,
          bushes: bushes,
          vines: vines,
          flower_garden_id: flower_garden_id,
          flowers: flowers,
          image: image
        });
        if(this.selectedFeatures.length === 1) {
          setTimeout(() => {
            this.text = this.$store.state.message.msg;
            this.snackbar = true;
            this.calcViewPolygon();
          }, 2000);
        }
        return;
      }

      let properties = this.selectedFeatures[0].properties;
      if (properties) {
        this.pushPlantData({
          id: properties.id,
          geometry: wktRepresenation,
          layer_id: this.layerTarget,
          age: age,
          height: height,
          diameter: diameter,
          serial_number: serial_number,
          sanitary_id: sanitary_id,
          category_id: category_id,
          status_id: status_id,
          district_id: this.district.id,
          in_charge: in_charge,
          planting_date: planting_date,
          registry_date: registry_date,
          quantity: quantity,
          length: length,
          area: area,
          vermin: vermin,
          diseases: diseases,
          events: events,
          type_id: this.typeTarget.id,
          breeds: breeds,
          lawn_name: lawn_name,
          lawn_type: lawn_type,
          bushes: bushes,
          vines: vines,
          flower_garden_id: flower_garden_id,
          flowers: flowers,
          image: image
        });
      } else {
        this.drawFeatures.forEach(e => {
          feature = this.formatGeoJSON.readFeature(e);
          wktRepresenation = this.formatWKT.writeFeature(feature);
          this.createPlantData({
            geometry: wktRepresenation,
            layer_id: this.layerTarget,
            age: age,
            height: height,
            diameter: diameter,
            serial_number: serial_number,
            sanitary_id: sanitary_id,
            category_id: category_id,
            status_id: status_id,
            district_id: this.district.id,
            in_charge: in_charge,
            planting_date: planting_date,
            registry_date: registry_date,
            quantity: quantity,
            length: length,
            area: area,
            vermin: vermin,
            diseases: diseases,
            events: events,
            type_id: this.typeTarget.id,
            breeds: breeds,
            lawn_name: lawn_name,
            lawn_type: lawn_type,
            bushes: bushes,
            vines: vines,
            flower_garden_id: flower_garden_id,
            flowers: flowers,
            image: image
          });
        });
      }
      this.selectedFeatures = [];
      this.drawFeatures = [];
      this.passport = false;
      setTimeout(() => {
        this.text = this.$store.state.message.msg;
        this.snackbar = true;
        this.calcViewPolygon();
      }, 2000);
    },

    async removePlants() {
      let properties = this.selectedFeatures[0].properties;
      if (!properties) {
        this.drawFeatures = this.drawFeatures.filter(
          item =>
            !(
              JSON.stringify(item.geometry) ===
              JSON.stringify(this.selectedFeatures[0].geometry)
            )
        );
        return;
      } else {
        await this.destroyPlantData(properties.id);
      }
      setTimeout(() => {
        this.selectedFeatures = [];
        this.drawFeatures = [];
        this.passport = false;
        this.text = this.$store.state.message.msg;
        this.snackbar = true;
        this.calcViewPolygon();
      }, 3000);
    },

    drawEndComment() {
      this.selectedFeaturesComment = [];
      if (this.drawFeaturesComment.length > 1) this.drawFeaturesComment.shift();
      this.selectedFeaturesComment.push(this.drawFeaturesComment[0]);
    },

    drawEnd(evt) {
      this.selectedFeatures = [];

      if (this.$store.state.user.userRole === 3) {
        var drawGeom = evt.feature.getGeometry();
        var sourceProj = this.$refs.map.getView().getProjection();
        const source = this.$refs.taxatorSource.$source;

        if (drawGeom instanceof Polygon) {
          var polygon = drawGeom.clone().transform(sourceProj, "EPSG:4326");
          var polygonCoord = polygon.getLinearRing(0).getCoordinates();
          for (var i = 0, ii = polygonCoord.length; i < ii; ++i) {
            var p1 = polygonCoord[i];
            var pgCoord = fromLonLat([p1[0], p1[1]]);
            source.forEachFeature(feature => {
              var taxatorGeom = feature.getGeometry();
              if (!taxatorGeom.intersectsCoordinate(pgCoord)) {
                alert("за пределами таксатор грид");
                this.drawFeatures = [];
                this.selectedFeatures = [];
                return;
              } else {
                this.selectedFeatures.push(
                  this.drawFeatures[this.drawFeatures.length - 1]
                );
              }
            });
          }
        } else if (drawGeom instanceof LineString) {
          var line = drawGeom.clone().transform(sourceProj, "EPSG:4326");
          var lineCoord = line.getCoordinates();
          for (var j = 0, jj = lineCoord.length; j < jj; ++j) {
            var l1 = lineCoord[j];
            var lCoord = fromLonLat([l1[0], l1[1]]);
            source.forEachFeature(feature => {
              var taxatorGeom = feature.getGeometry();
              if (!taxatorGeom.intersectsCoordinate(lCoord)) {
                alert("за пределами таксатор грид");
                this.drawFeatures = [];
                this.selectedFeatures = [];
                return;
              } else {
                this.selectedFeatures.push(
                  this.drawFeatures[this.drawFeatures.length - 1]
                );
              }
            });
          }
        } else {
          var point = drawGeom.clone().transform(sourceProj, "EPSG:4326");
          var pointCoord = point.getCoordinates();
          var pCoord = fromLonLat([pointCoord[0], pointCoord[1]]);
          source.forEachFeature(feature => {
            var taxatorGeom = feature.getGeometry();
            if (!taxatorGeom.intersectsCoordinate(pCoord)) {
              alert("за пределами таксатор грид");
              this.drawFeatures = [];
              this.selectedFeatures = [];
              return;
            } else {
              this.selectedFeatures.push(
                this.drawFeatures[this.drawFeatures.length - 1]
              );
            }
          });
        }
      } else {
        this.selectedFeatures.push(
          this.drawFeatures[this.drawFeatures.length - 1]
        );
      }
    },

    async onSelect(feature) {
      if (this.isDraw || this.editObj) {
        let props;
        if (!this.passport) this.passport = true;
        if (!feature.json.properties) {
          props = { type_id: this.typeTarget.id };
        } else {
          props = await this.getPlantById(feature.json.properties.id);
        }
        props.geometry = feature.json.geometry;
        this.typeTarget = this.types.find(e => {
          return e.id === props.type_id;
        });
        setTimeout(() => {
          if (JSON.stringify(this.properties) === JSON.stringify({})) {
            this.properties = props;
          } else if (feature.json.properties)
            if (feature.json.properties.id) this.properties = props;
        }, 1);
        this.geoCoordinates = Object.assign(
          {},
          feature.json.geometry.coordinates
        );
        let geometry = this.formatGeoJSON.readFeature(feature.json.geometry);
        let wktRepresenation = this.formatWKT.writeFeature(geometry);
        this.district = await this.getDistrictByArea(wktRepresenation);
      }
    },

    onUnselect(feature) {
      if (feature.json.properties) {
        this.properties = {};
        this.geoCoordinates = {};
        this.geometries = { plants: [] };
        this.passport = false;
      }
    },

    async onSelectComment(feature) {
      console.log(feature.json.properties);
      this.propertiesComment = Object.assign(feature.json.properties, {
        geometry: feature.json.geometry
      });
    },

    async onReportSelect(feature) {
      this.passport = false;
      this.selectedFeatures = [];
      let geometry = this.formatGeoJSON.readFeature(feature.json.geometry);
      let wktRepresenation = this.formatWKT.writeFeature(geometry);
      this.reportGeometry = wktRepresenation;
      let response;

      let districts = "";
      if (this.$store.state.settings.ids_districts)
        districts = `district_id=${this.$store.state.settings.ids_districts}&`;
      let types = "";
      if (this.$store.state.settings.ids_types)
        types = `type_id=${this.$store.state.settings.ids_types}&`;
      let breeds = "";
      if (this.$store.state.settings.ids_breeds)
        breeds = `breed_id=${this.$store.state.settings.ids_breeds}&`;
      let sanitary = "";
      if (this.$store.state.settings.ids_sanitary)
        sanitary = `sanitary_id=${this.$store.state.settings.ids_sanitary}&`;
      let statuses = "";
      if (this.$store.state.settings.ids_statuses)
        statuses = `status_id=${this.$store.state.settings.ids_statuses}&`;
      let events = "";
      if (this.$store.state.settings.ids_events)
        events = `event_id=${this.$store.state.settings.ids_events}&`;
      let vermin = "";
      if (this.$store.state.settings.ids_vermin)
        vermin = `vermin_id=${this.$store.state.settings.ids_vermin}&`;
      let diseases = "";
      if (this.$store.state.settings.ids_diseases)
        diseases = `disease_id=${this.$store.state.settings.ids_diseases}&`;
      let redbook = "";
      if (this.$store.state.settings.redbookTarget)
        redbook = `redbook=${this.$store.state.settings.redbookTarget}&`;
      let layer = "";
      if (this.layerTarget !== 0)
        layer = `&layer_id=${this.$store.state.settings.layerTarget}&`;

      response = await Vue.axios.get(
        `${URL_API}type/getbyfilter?${layer}${districts}${types}${breeds}${sanitary}${statuses}${events}${vermin}${diseases}${redbook}geometry=${this.reportGeometry}`
      );
      this.reportCount = response.data;
      this.reportPassport = true;
    },

    drawEndReport() {
      this.selectedReportFeatures = [];
      this.selectedReportFeatures.push(
        this.drawReportFeatures[this.drawReportFeatures.length - 1]
      );
    },

    drawStartReport() {
      this.selectedReportFeatures = [];
      this.drawReportFeatures = [];
    },

    onReportUnselect() {
      this.reportPassport = false;
    },

    async onAirSelect(sensor) {
      if (sensor == "clarity") {
        console.log(this.selectedClarities);
        this.propertiesAir = this.selectedClarities[0].properties;
        this.geoCoordinates = this.selectedClarities[0].geometry.coordinates;
      } else if (sensor == "smarteco") {
        console.log(this.selectedSmarteco);
        this.propertiesAir = this.selectedSmarteco[0].properties;
        this.geoCoordinates = this.selectedSmarteco[0].geometry.coordinates;
      } else if (sensor == "kazgidromet") {
        console.log(this.selectedKazgidromet);
        this.propertiesAir = this.selectedKazgidromet[0].properties;
        this.geoCoordinates = this.selectedKazgidromet[0].geometry.coordinates;
      }
      this.passportAir = true;
    },

    async onAirUnselect() {
      this.passportAir = false;
      this.propertiesAir = {};
      this.geoCoordinates = {};
      this.selectedClarities = [];
      this.selectedSmarteco = [];
      this.selectedKazgidromet = [];
    },

    async selectedObjReport() {
      let amount = this.reportCount.reduce(
        (total, array) => total + array.count,
        0
      );
      if (amount > 5000000) {
        this.text = amount + " объектов слишком много для формирования отчета";
        this.snackbar = true;
      } else {
        let isContinue = confirm(
          `Для отчёта выбрано ${amount} объектов. Время формирования отчёта ~${amount /
            300000} минут. Продолжить?`
        );
        if (!isContinue) return;
        let districts = "";
        if (this.$store.state.settings.ids_districts)
          districts = `district_id=${this.$store.state.settings.ids_districts}&`;
        let types = "";
        if (this.$store.state.settings.ids_types)
          types = `type_id=${this.$store.state.settings.ids_types}&`;
        let breeds = "";
        if (this.$store.state.settings.ids_breeds)
          breeds = `breed_id=${this.$store.state.settings.ids_breeds}&`;
        let sanitary = "";
        if (this.$store.state.settings.ids_sanitary)
          sanitary = `sanitary_id=${this.$store.state.settings.ids_sanitary}&`;
        let statuses = "";
        if (this.$store.state.settings.ids_statuses)
          statuses = `status_id=${this.$store.state.settings.ids_statuses}&`;
        let events = "";
        if (this.$store.state.settings.ids_events)
          events = `event_id=${this.$store.state.settings.ids_events}&`;
        let vermin = "";
        if (this.$store.state.settings.ids_vermin)
          vermin = `vermin_id=${this.$store.state.settings.ids_vermin}&`;
        let diseases = "";
        if (this.$store.state.settings.ids_diseases)
          diseases = `disease_id=${this.$store.state.settings.ids_diseases}&`;
        let redbook = "";
        if (this.$store.state.settings.redbookTarget)
          redbook = `redbook=${this.$store.state.settings.redbookTarget}&`;
        let layer = "";
        if (this.layerTarget !== 0)
          layer = `&layer_id=${this.$store.state.settings.layerTarget}&`;
        await Vue.axios({
          url: `${URL_API}plant/exportExcel?${layer}${districts}${types}${breeds}${sanitary}${statuses}${events}${vermin}${diseases}${redbook}geometry=${this.reportGeometry}`,
          method: "GET",
          responseType: "blob"
        }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "file.xlsx");
          document.body.appendChild(link);
          link.click();
        });
        this.reportPassport = false;
        this.selectionObj = false;
        this.selectedReportFeatures = [];
        this.drawReportFeatures = [];
      }
    },

    measureDistance() {
      this.distance = !this.distance;
      this.distanceFeatures = [];
    },

    measureArea() {
      this.area = !this.area;
      this.areaFeatures = [];
    },

    async onMapPointerMove(evt) {
      if (evt.dragging) {
        return;
      }
      if (
        this.isDraw === false &&
        this.editObj === false &&
        this.selectedGroup === false &&
        this.selectionObj === false &&
        this.distance === false &&
        this.area === false
      ) {
        let map = this.$refs.map;
        let zoom = map.getView().getZoom();
        if (zoom > 18) {
          var features = [];
          await this.$refs.map.forEachFeatureAtPixel(evt.pixel, function(
            feature
          ) {
            features.push(feature);
          });
          if (features.length > 0) {
            this.mapCursor = "pointer";
            var f1 = features[0];
            var curType = f1.get("type_id");
            this.curBreedId = f1.get("id");
            var data;
            var res;
            this.breedPosition = evt.coordinate;

            if (this.curBreedId !== this.lstBreedId) {
              this.lstBreedId = this.curBreedId;

              switch (curType) {
                case 1:
                  res = await Vue.axios.get(
                    `${URL_API}breed/getByPlantId?id=${this.curBreedId}`
                  );
                  break;
                case 2:
                  res = await Vue.axios.get(
                    `${URL_API}bush/getByPlantId?id=${this.curBreedId}`
                  );
                  break;
                default:
                  return;
              }

              data = res.data;
              if (data.length > 0) {
                this.breedName = data[0].name;
              }
              this.curBreedId = undefined;
              //this.tooltipHide = "";
            }
          } else {
            //this.tooltipHide = "d-hide";
            this.mapCursor = "default";
            this.breedPosition = this.breedName = this.curBreedId = this.lstBreedId = undefined;
          }
        } else {
          this.mapCursor = "default";
          this.breedPosition = this.breedName = this.curBreedId = this.lstBreedId = undefined;
        }
      } else if (this.distance === true || this.area === true) {
        //this.tooltipHide = "d-hide";
      } else {
        //this.tooltipHide = "d-hide";
      }
    },

    selectionTool() {
      this.selectionObj = !this.selectionObj;
      this.selectedReportFeatures = [];
      this.drawReportFeatures = [];
    },

    onComment() {
      this.isComment = !this.isComment;
      if (!this.isComment) {
        this.drawFeaturesComment = [];
        this.selectedFeaturesComment = [];
      }
    },

    onCreate() {
      this.isDraw = !this.isDraw;
      if (!this.isDraw) {
        this.drawFeatures = [];
        this.selectedFeatures = [];
        this.passport = false;
      }
    },

    onEdit() {
      if (this.selectedFeatures.length > 1) {
        let next = confirm("Вы хотите отменить копирование группы?");
        if (!next) {
          return;
        }
      }
      this.editObj = !this.editObj;
      if (this.editObj) {
        this.$refs.select.setActive(true);
        this.$refs.selectReport.setActive(true);
      } else {
        this.$refs.select.setActive(false);
        this.$refs.selectReport.setActive(false);
        this.selectedFeatures = [];
      }
    },

    searchObjectData(searchID) {
      this.searchID = searchID;
    },

    searchObjectMsg() {
      this.text = this.$store.state.message.msg;
      this.snackbar = true;
    },

    filterMsg() {
      this.text = this.$store.state.message.msg;
      this.snackbar = true;
    },

    formatLength(line) {
      let length = getLength(line);
      let output;
      if (length > 100) {
        output = Math.round((length / 1000) * 100) / 100 + " " + "км";
      } else {
        output = Math.round(length * 100) / 100 + " " + "м";
      }
      return output;
    },

    formatArea(polygon) {
      let area = getArea(polygon);
      let output;
      if (area > 10000) {
        output = Math.round((area / 1000000) * 100) / 100 + " " + "км2";
      } else {
        output = Math.round(area * 100) / 100 + " " + "м2";
      }
      return output;
    },

    drawStartLength(evt) {
      this.breedPosition = evt.json.geometry.coordinates[0];
      this.sketch = evt.feature;

      let tooltipCoord = evt.coordinate;

      this.listener = this.sketch.getGeometry().on("change", evt => {
        let geom = evt.target;
        let output;
        if (geom instanceof Polygon) {
          output = this.formatArea(geom);
          tooltipCoord = geom.getInteriorPoint().getCoordinates();
        } else if (geom instanceof LineString) {
          output = this.formatLength(geom);
          tooltipCoord = geom.getLastCoordinate();
        }
        /*measureTooltipElement.innerHTML = output;
        measureTooltip.setPosition(tooltipCoord);*/
        this.breedName = output;
        this.tooltipHide = "";
        console.log(tooltipCoord);
      });
    },

    drawEndLength(evt) {
      console.log(evt);
    },

    async fetchClarities() {
      let response = await Vue.axios.get(
          `https://clarity-data-api.clarity.io/v1/devices?org=adbkazBW23`,
          {
            headers: {
              "x-api-key": "xbWs4m6uFLQl6VbXWd0Xcf4cnEjokvhdYe3B1HuJ"
            }
          }
      );
      const allCodes = response.data.map(device => device.code).join(",");

      let response2 = await Vue.axios.post(
          `https://proxy.eco-almaty.kz/clarity?url=https://clarity-data-api.clarity.io/v1/measurements`,
          {
            startTime: new Date(new Date().setHours(new Date().getHours() - 6)).toISOString().replace(".000", ""),
            outputFrequency: "hour",
            code: allCodes
          }
      );

      this.clarities = response.data.map(obj => {
        const overallStatus = obj.overallStatus || "Unknown";
        const code = obj.code;
        const workingStartAt = obj.workingStartAt;

        const matchedDevice = response2.data.find(
            device => device.deviceCode === obj.code
        );
        const characteristics = matchedDevice
            ? matchedDevice.characteristics
            : {};
        const testDate = matchedDevice ? matchedDevice.time : "";

        return {
          type: "Feature",
          geometry: obj.location,
          properties: {
            code,
            workingStartAt,
            testDate,
            characteristics,
            overallStatus
          }
        };
      }).filter(point => point.properties.characteristics && point.properties.characteristics.pm2_5ConcMass?.value);
    },

    async fetchEcoProps(id) {
      let targetUrl;
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 2);
      const formattedDate = currentDate.toISOString().split("T")[0];
      targetUrl = `http://smarteco.kz:8084/api/MeasuredDatas?MonitoringPostId=${id}&Averaged=true&DateTimeFrom=${formattedDate}&DateTimeTo=${formattedDate}`;
      const encodedUrl = encodeURIComponent(targetUrl);
      const response = await Vue.axios.get(
          `https://proxy.eco-almaty.kz/smarteco?url=${encodedUrl}`
      );
      const pm25 = response.data.find(
          item =>
              item.measuredParameter &&
              item.measuredParameter.nameRU === "Взвешенные частицы PM2,5"
      );
      return pm25 ? pm25.value : null;
    },

    async fetchEcos() {
      let response3 = await Vue.axios.get(
          `https://proxy.eco-almaty.kz/smarteco?url=http://smarteco.kz:8084/api/MonitoringPosts?DataProviderId=3&PollutionEnvironmentId=2`
      );

      const ecosWithPm25 = (await Promise.all(
        response3.data
          .filter(obj => obj.project && obj.project.id === 3)
          .map(async obj => {
            const pm25 = await this.fetchEcoProps(obj.id);
            return {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: [obj.eastLongitude, obj.northLatitude]
              },
              properties: {
                id: obj.id,
                name: obj.name,
                info: obj.additionalInformation,
                pm25: pm25
              }
            };
          })
      )).filter(point => point.properties.pm25 !== null);

      this.ecos = ecosWithPm25;
    },

    async fetchKazgidrometProps(id) {
      let targetUrl;
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 2);
      const formattedDate = currentDate.toISOString().split("T")[0];
      targetUrl = `http://atmosphera.kz:4003/simple/averages?key=064d096e086dff2cadc691ebffaaeed5978a0763c1655670e8f0a466f9fcafab&stationNumber=${id}&after=${formattedDate}`;
      const encodedUrl = encodeURIComponent(targetUrl);
      const response = await Vue.axios.get(
          `https://proxy.eco-almaty.kz/kazgidromet?url=${encodedUrl}`
      );

      const pm25 = response.data.find(item => item.code === "PM2.5");
      return pm25 ? pm25.value : null;
    },

    async fetchKazgidromets() {
      const points = [
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [76.875983, 43.356909]
          },
          properties: {
            name: "ПНЗ №2",
            id: 25,
            type: "А"
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [76.95219028, 43.33728889]
          },
          properties: {
            name: "ПНЗ №29",
            id: 26,
            type: "А"
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [76.88959278, 43.18015528]
          },
          properties: {
            name: "ПНЗ №31",
            id: 27,
            type: "А"
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [76.851363, 43.298772]
          },
          properties: {
            name: "ПНЗ №30",
            id: 28,
            type: "А"
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [76.844007, 43.271427]
          },
          properties: {
            name: "ПНЗ №27",
            id: 55,
            type: "А"
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [76.926401, 43.220247]
          },
          properties: {
            name: "ПНЗ №1",
            id: 56,
            type: "А"
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [76.992746, 43.374209]
          },
          properties: {
            name: "ПНЗ №4",
            id: 57,
            type: "А"
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [76.816496, 43.258318]
          },
          properties: {
            name: "ПНЗ №3",
            id: 58,
            type: "А"
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [76.925926, 43.30073]
          },
          properties: {
            name: "ПНЗ №6",
            id: 59,
            type: "А"
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [77.004808, 43.36374]
          },
          properties: {
            name: "ПНЗ №28",
            id: 97,
            type: "А"
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [76.93341833, 43.2379475]
          },
          properties: {
            name: "ПНЗ №1",
            id: 102,
            type: "Р"
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [76.93427917, 43.26943389]
          },
          properties: {
            name: "ПНЗ №12",
            id: 103,
            type: "Р"
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [76.92051611, 43.32397333]
          },
          properties: {
            name: "ПНЗ №16",
            id: 104,
            type: "Р"
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [76.8324675, 43.23270278]
          },
          properties: {
            name: "ПНЗ №25",
            id: 105,
            type: "Р"
          }
        },
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [76.87552417, 43.25029139]
          },
          properties: {
            name: "ПНЗ №26",
            id: 106,
            type: "Р"
          }
        }
      ];

      this.kazgidromet = (await Promise.all(
        points.map(async point => {
          const pm25Value = await this.fetchKazgidrometProps(point.properties.id);

          return {
            ...point,
            properties: {
              ...point.properties,
              pm25: pm25Value
            }
          };
        })
      )).filter(point => point.properties.pm25);
    }
  },

  async mounted() {
    this.$store.state.settings.map = this.$refs.map;
    this.$refs.select.setActive(false);
    this.$refs.selectReport.setActive(false);

    this.fetchClarities();
    this.fetchEcos();
    this.fetchKazgidromets();
  },

  components: {
    AirPassportKazgidromet,
    AirPassportSmarteco,
    AirPassportClarity,
    CommentPassport,
    TreePassport,
    BushPassport,
    CurtainTreePassport,
    CurtainBushPassport,
    FlowerGardenPassport,
    LawnPassport,
    HedgePassport,
    VinesPassport,
    ReportPassport,
    Filters,
    PlantStyle,
  }
};
</script>

<style scoped>
.ol-attribution {
  display: none;
}

::v-deep .v-input__slot {
  margin: 0;
  max-height: 32px;
  min-height: 32px !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-btn:not(.v-btn--round).v-size--default {
  height: 32px;
}

::v-deep .v-list-item__action {
  margin: 0;
}

.ol-tooltip {
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  color: white;
  padding: 4px 8px;
  opacity: 0.7;
  white-space: nowrap;
  font-size: 12px;
}
.ol-tooltip-measure {
  opacity: 1;
  font-weight: bold;
}
.ol-tooltip-static {
  background-color: #ffcc33;
  color: black;
  border: 1px solid white;
}
.ol-tooltip-measure:before,
.ol-tooltip-static:before {
  border-top: 6px solid rgba(0, 0, 0, 0.5);
  border-right: 6px solid transparent;
  border-left: 6px solid transparent;
  content: "";
  position: absolute;
  bottom: -6px;
  margin-left: -7px;
  left: 50%;
}
.ol-tooltip-static:before {
  border-top-color: #ffcc33;
}
</style>
